import React from 'react';
import {Helmet} from 'react-helmet';
import ReactMarkdown from 'react-markdown';
import photoCompressHeader from './photo-compress-header.md';
import photoCompressSectionOne from './photo-compress-section-one.md';
import photoCompressSectionTwo from './photo-compress-section-two.md';
import photoCompressSectionThree from './photo-compress-section-three.md';
import photoCompressSectionFour from './photo-compress-section-four.md';
import photoCompressHowToHeader from './photo-compress-how-to-header.md';
import photoCompressHowToStepOne from './photo-compress-how-to-step-one.md';
import photoCompressHowToStepTwo from './photo-compress-how-to-step-two.md';

import {Features} from '../..';

import styles from '../styles';

import image2 from './assets/compress-page-2.jpg';
import image4 from './assets/compress-page-4.jpg';

const PhotoCompress = () => (
  <Features
    customMasthead={photoCompressHeader}
    linkLocation={'/compress-images'}
  >
    <Helmet>
      <title>Compress JPG and PNG images with ImageResize.org</title>
      <meta
        name="description"
        content="Easily compress your JPG and PNG files by uploading them to our image compressor."
      />
    </Helmet>
    <div className='container'>
      <div className='twoSections verticallyCentered content'>
        <ReactMarkdown className='section' source={photoCompressSectionOne} />
        <div className='section'></div>
      </div>
    </div>
    <div className='darkSection'>
      <div className='twoSections verticallyCentered container'>
        <div className='section'>
          <img className={styles.featureImage} src={image2} alt="" />
        </div>
        <ReactMarkdown className='section' source={photoCompressSectionTwo} />
      </div>
    </div>
    <div className='twoSections verticallyCentered container'>
      <ReactMarkdown className='section' source={photoCompressSectionThree} />
      <div className='section'></div>
    </div>
    <div className='darkSection'>
      <div className='twoSections verticallyCentered container'>
        <div className='section'>
          <img className={styles.featureImage} src={image4} alt="" />
        </div>
        <ReactMarkdown className='section' source={photoCompressSectionFour} />
      </div>
    </div>
    <div className='container'>
      <ReactMarkdown className='section center' source={photoCompressHowToHeader} />
    </div>
    <div className={`${styles.howToGrid} ${styles.twoStep}`}>
      <div className={styles.howToItem}>
        <div className={styles.step}>01</div>
        <ReactMarkdown source={photoCompressHowToStepOne} />
      </div>
      <div className={styles.howToItem}>
        <div className={styles.step}>02</div>
        <ReactMarkdown source={photoCompressHowToStepTwo} />
      </div>
    </div>
  </Features>
);

export default PhotoCompress;



// WEBPACK FOOTER //
// ./src/containers/Features/PhotoCompress/index.jsx